export default __webpack_public_path__ + "static/MCA_Logo_Gold-f27401d4c464addf68fc22d36a850f06.png";